import { withInstall } from '@jdesign-vue/utils'

import Tag from './src/tag.vue'

export const JdTag = withInstall(Tag)
export default JdTag

export * from './src/tag'
